import styled from 'styled-components';
import { PROGRESS_BAR_COLORS } from '../../../updateForm/components/ModalSLAInfo/utils';

export const EditProtocolByNumber = styled.div`
  cursor: pointer;
  transition: ease-in-out 0.4s;

  &:hover {
    color: #4892f9;
    scale: 1.1;
  }
`;

export const ProgressBarContainer = styled.div`
  width: 100%;
  max-width: 10rem;
  border-radius: 4px;
  overflow: hidden;
  height: 27px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ProgressBarBackground = styled.div`
  width: 100%;
  background-color: #bbbbbb;
  border-radius: 4px;
  overflow: hidden;
  height: 100%;
  position: relative;
`;

export const ProgressBar = styled.div`
  height: 100%;
  line-height: 27px;
  color: white;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  border-radius: 4px;
  background-color: ${(props) => props.color || PROGRESS_BAR_COLORS.VALUE_100};
  width: ${(props) => `${props.percentage}%`};
  position: absolute;
  top: 0;
  left: 0;
`;
export const NoPaddingDiv = styled.div`
  padding: 0;
`;
